export enum Feature {
  DakotaRoofSnoop = 'dakota-roof-snoop',
  MontanaCustomShedsRoofSnoop = 'montana-custom-sheds-roof-snoop',
  DuratufPressBentRoof = 'duratuf-press-bent-roof',
  RidgeVent = 'ridge-vent',
}
